import React, {Fragment} from 'react';
import Hero from '../../components/Hero';
import About from '../../components/about';
import ContactSection from '../../components/ContactSection';
import Applications from '../../components/Applications';
import Footer from '../../components/Footer';
import Navbar from '../../components/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Element} from 'react-scroll'

const HomePage = () => {
    return(
        <Fragment>
            <Navbar />
            <Element name='home'>
                <Hero/>
            </Element>
            <Element name='about'>
                <About/>
            </Element>
            <Element name='contact'>
                <ContactSection/>
            </Element>
            <Element name='applications'>
                <Applications/>
            </Element>
            <Footer/>
        </Fragment>
    )
};

export default HomePage;


